import { isCompanyId, isNotDefined, isRoleId, isTeamId, isUserId, type DashboardScopeId } from '@terros/common'
import type { DashboardScopeTarget } from './types'

export function getDashboardScopeTarget({
  scopeId,
  scopeName,
  companyName,
  companyLabel,
}: {
  scopeId: DashboardScopeId | null
  scopeName: string | null
  companyName?: string
  companyLabel: string
}): DashboardScopeTarget | undefined {
  if (isNotDefined(scopeId)) return undefined
  if (isCompanyId(scopeId))
    return { entityId: scopeId, name: scopeName ?? companyName ?? companyLabel, kind: 'company' }
  if (isTeamId(scopeId)) return { entityId: scopeId, name: scopeName ?? scopeId, kind: 'team' }
  if (isUserId(scopeId)) return { entityId: scopeId, name: scopeName ?? scopeId, kind: 'user' }
  if (isRoleId(scopeId)) return { entityId: scopeId, name: scopeName ?? scopeId, kind: 'role' }
  return undefined
}
